export default "__VITE_ASSET__d7831b2b__"